module.exports = __webpack_public_path__ + "static/media/yellowfish2.9f97a926.png";